<div class="rs-flex-columns">
  <div class="rs-tbl rs-maxw">
    <div class="rs-tbl-cell">
      <p>
        <span class="rs-word-break-all">{{ alias.aliasId }}</span>
      </p>
    </div>
    <div class="rs-tbl-cell rs-valign-middle text-right">
      <p>
        <button
          class="rs-link-action rs-link-action-remove"
          aria-haspopup="true"
          (click)="removeAlias.emit(alias.aliasId)"
        >
          <span aria-hidden="true" class="rs-link-action-label show-for-medium-up">{{
            'aliases.delete.button' | translate
          }}</span
          ><span class="rs-action-link-icon" title="Delete"
            ><span class="show-for-sr">{{ alias.aliasId }}</span
            >></span
          >
        </button>
      </p>
    </div>
  </div>
</div>
